import { SelectedMarker } from '@/entities/map'
import {
  createOverlay,
  createBaseOverlay,
  BaseOverlayOptions,
  BaseOverlay,
} from '@/shared/lib'

export type LandmarkOverlayProps = Omit<
  BaseOverlayOptions,
  'map' | 'position' | 'onClick'
> & {
  onClick: (marker?: SelectedMarker) => void
}

type LandmarkOverlayOptions = BaseOverlayOptions & LandmarkOverlayProps

export interface LandmarkOverlay extends BaseOverlay {
  isSelected: boolean
  markAsSelected(): void
  markAsDeselected(): void
}

export const createLandmarkOverlay = () => {
  const BaseOverlay = createBaseOverlay()

  const LandmarkOverlay = createOverlay<
    LandmarkOverlay,
    LandmarkOverlayOptions
  >({
    base: BaseOverlay,
    initialize,
  })

  function initialize(this: LandmarkOverlay, options: LandmarkOverlayOptions) {
    this.isSelected = false

    this._onClick = () => {
      this.markAsSelected()
      const position = this.getPosition()

      options.onClick?.({
        id: this.id,
        type: 'landmark',
        position: { lat: position.lat(), lng: position.lng() },
        nextZoomLevel: options.nextZoomLevel,
      })
    }
  }

  LandmarkOverlay.prototype.markAsSelected = function () {
    if (this._element.firstElementChild instanceof HTMLElement) {
      this.isSelected = true
      this._element.firstElementChild.classList.add('selected')
    }
  }

  LandmarkOverlay.prototype.markAsDeselected = function () {
    if (this._element.firstElementChild instanceof HTMLElement) {
      this.isSelected = false
      this._element.firstElementChild.classList.remove('selected')
    }
  }

  return LandmarkOverlay
}
